// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__BqIi5","social":"socials__social__QhISf","rtlSocial":"socials__rtlSocial__oRkXS","icon":"socials__icon__emE72","navOpen":"socials__navOpen__PiAYA"};